import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TimesheetCode } from "@app/models/rest/timesheet-code";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";

@Component({
  selector: "app-timesheet-code-chooser",
  templateUrl: "./timesheet-code-chooser.component.html",
  styleUrls: ["./timesheet-code-chooser.component.css"],
  imports: [MatFormField, MatLabel, MatSelect, MatOption]
})
export class TimesheetCodeChooserComponent {
  @Input() public timesheetCodes: TimesheetCode[];
  @Input() public selectedCode: TimesheetCode;
  @Input() public displayAs: string;
  @Output() codeChanged = new EventEmitter<TimesheetCode>();

  onCodeChange(event: any): void {
    this.codeChanged.emit(event.value);
  }
}
